import { render, staticRenderFns } from "./RbuItemModuleGroup.vue?vue&type=template&id=53057f37"
import script from "./RbuItemModuleGroup.vue?vue&type=script&lang=js"
export * from "./RbuItemModuleGroup.vue?vue&type=script&lang=js"
import style0 from "./RbuItemModuleGroup.vue?vue&type=style&index=0&id=53057f37&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports